import { getFirebaseDb } from './firebase';
import { collection, getDocs } from 'firebase/firestore';

export async function getBookmarks(userId: string) {
    try {
        const db = await getFirebaseDb();
        const snapshot = await getDocs(collection(db, 'users', userId, 'bookmarks'));
        return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Failed to get bookmarks:', error);
        return [];
    }
}
